const actions = require("./actions");

const roles = {
  SUPER_ADMIN: {
    name: "super_admin",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      actions.ACCESS_COMPANY_LISTING,
      actions.ACCESS_ADDRESS_SUMMARY,
      actions.ACCESS_ADD_NEW_COMPANY,
      actions.ACCESS_ADD_NEW_ADDRESS,
      actions.ACCESS_VIEW_COMPANY,
      actions.ACCESS_EDIT_COMPANY,
      actions.ACCESS_EDIT_ADDRESS,
      actions.ACCESS_COMPANY_USER_LISTING,
      actions.ACCESS_COMPANY_PICKUPADDRESSES_LISTING,
      actions.ACCESS_COMPANY_BILLINGADDRESSES_LISTING,
      actions.ACCESS_ADD_LOGISTICS,
      actions.ACCESS_VIEW_LOGISTICS,
      actions.ACCESS_EDIT_LOGISTICS,
      actions.ACCESS_LOGISTICS_LISTING,
      actions.ACCESS_ADD_LAB,
      actions.ACCESS_VIEW_LAB,
      actions.ACCESS_EDIT_LAB,
      actions.ACCESS_LAB_LISTING,
      actions.ACCESS_ADD_TEST,
      actions.ACCESS_COMPANY_CATALOG_LISTING,
      actions.ACCESS_MASTER_CATALOG,
      actions.ACCESS_ORDER_LISTING,
      actions.ACCESS_USER_SUMMARY,
      actions.ACCESS_ADD_COMPANY_CATALOG,
      actions.ACCESS_EDIT_COMPANY_CATALOG,
      actions.ACCESS_EDIT_TEST_PRICE_IN_COMPANY_CATALOG,
      actions.ACCESS_REMOVE_TEST_FROM_COMPANY_CATALOG,
      actions.ACCESS_COMPANY_CATALOG,
      actions.ACCESS_EDIT_USER,
      actions.ACCESS_VIEW_USER_DETAILS,
      actions.ACCESS_ADD_USER,
      actions.ACCESS_CATALOG_MANAGEMENT,
      actions.BO_DOWNLOAD_PURCHASE_ORDER,
      actions.BO_ACCESS_ORDER_DETAILS,
      actions.BO_APPROVE_ORDER_PAYMENT,
      actions.BO_APPROVE_PURCHASE_ORDER,
      actions.BO_UPDATE_ORDER_STATUS,
      actions.BO_UPLOAD_REPORT,
      actions.BO_DOWNLOAD_REPORT,
      actions.BO_ADD_ORDER_INSTRUCTIONS,
      actions.BO_ACCESS_ORDER_INSTRUCTIONS,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ADD_PACKAGE,
      actions.BO_EDIT_PACKAGE,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.BO_ACCESS_BOOK_TEST,
      actions.BO_UPDATE_ORDER_LAB,
      actions.BO_UPDATE_ORDER_LOGISTICS,
      actions.BO_REGRET_ORDER,
      actions.BO_ACCESS_PAYMENT_REMINDER,
      actions.BO_CREATE_SERVICE_REQUEST,
      actions.BO_ACCESS_ASSETS_LISTING,
      actions.BO_ACCESS_SAMPLER_LISTING,
      actions.BO_DASHBOARD_NEW,
      actions.BO_DASHBOARD_NEW_SAMPLING,
      actions.BO_DASHBOARD_NEW_COMMODITY,
      actions.BO_DASHBOARD_NEW_TESTING,
      actions.BO_DASHBOARD_NEW_TAT,
      actions.BO_ACCESS_ASSETS_DETAIL_VIEW,
      actions.ACCESS_LAB_PORTAL,
      actions.BO_DASHBOARD_NEW_SAMPLING_COVERAGE,
      actions.BO_DASHBOARD_NEW_REPORT,
      actions.BO_DASHBOARD_NEW_REGRET,
      actions.BO_DASHBOARD_NEW_COMPLIANCE
    ],
  },
  AGNEXT_ADMIN: {
    name: "agnext_admin",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      actions.ACCESS_COMPANY_LISTING,
      actions.ACCESS_ADDRESS_SUMMARY,
      actions.ACCESS_ADD_NEW_COMPANY,
      actions.ACCESS_ADD_NEW_ADDRESS,
      actions.ACCESS_VIEW_COMPANY,
      actions.ACCESS_EDIT_COMPANY,
      actions.ACCESS_EDIT_ADDRESS,
      actions.ACCESS_COMPANY_USER_LISTING,
      actions.ACCESS_COMPANY_PICKUPADDRESSES_LISTING,
      actions.ACCESS_COMPANY_BILLINGADDRESSES_LISTING,
      actions.ACCESS_ADD_LOGISTICS,
      actions.ACCESS_VIEW_LOGISTICS,
      actions.ACCESS_EDIT_LOGISTICS,
      actions.ACCESS_LOGISTICS_LISTING,
      actions.ACCESS_ADD_LAB,
      actions.ACCESS_VIEW_LAB,
      actions.ACCESS_EDIT_LAB,
      actions.ACCESS_LAB_LISTING,
      actions.ACCESS_ADD_TEST,
      actions.ACCESS_COMPANY_CATALOG_LISTING,
      actions.ACCESS_ORDER_LISTING,
      actions.ACCESS_USER_SUMMARY,
      actions.ACCESS_ADD_COMPANY_CATALOG,
      actions.ACCESS_EDIT_COMPANY_CATALOG,
      actions.ACCESS_REMOVE_TEST_FROM_COMPANY_CATALOG,
      actions.ACCESS_COMPANY_CATALOG,
      actions.ACCESS_EDIT_USER,
      actions.ACCESS_VIEW_USER_DETAILS,
      actions.ACCESS_ADD_USER,
      actions.ACCESS_CATALOG_MANAGEMENT,
      actions.BO_DOWNLOAD_PURCHASE_ORDER,
      actions.BO_ACCESS_ORDER_DETAILS,
      actions.BO_APPROVE_ORDER_PAYMENT,
      actions.BO_APPROVE_PURCHASE_ORDER,
      actions.BO_UPDATE_ORDER_STATUS,
      actions.BO_UPLOAD_REPORT,
      actions.BO_DOWNLOAD_REPORT,
      actions.BO_ADD_ORDER_INSTRUCTIONS,
      actions.BO_ACCESS_ORDER_INSTRUCTIONS,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ADD_PACKAGE,
      actions.BO_EDIT_PACKAGE,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.BO_ACCESS_BOOK_TEST,
      actions.BO_UPDATE_ORDER_LAB,
      actions.BO_UPDATE_ORDER_LOGISTICS,
      actions.BO_REGRET_ORDER,
      actions.BO_ACCESS_PAYMENT_REMINDER,
      actions.BO_ACCESS_ASSETS_LISTING,
      actions.BO_ACCESS_SAMPLER_LISTING,
      actions.BO_ACCESS_ASSETS_DETAIL_VIEW,
      actions.ACCESS_LAB_PORTAL,
      actions.BO_DASHBOARD_NEW,
      actions.BO_DASHBOARD_NEW_SAMPLING,
      actions.BO_DASHBOARD_NEW_COMMODITY,
      actions.BO_DASHBOARD_NEW_TESTING,
      actions.BO_DASHBOARD_NEW_TAT,
      actions.BO_DASHBOARD_NEW_SAMPLING_COVERAGE,
      actions.BO_DASHBOARD_NEW_REPORT,
      actions.BO_DASHBOARD_NEW_REGRET,
       actions.BO_DASHBOARD_NEW_COMPLIANCE
    ],
  },
  AGNEXT_REVIEWER: {
    name: "agnext_reviewer",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      actions.ACCESS_ORDER_LISTING,
      actions.BO_ACCESS_ORDER_DETAILS,
      actions.BO_APPROVE_PURCHASE_ORDER,
      actions.BO_UPDATE_ORDER_STATUS,
      actions.BO_UPLOAD_REPORT,
      actions.BO_DOWNLOAD_REPORT,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.BO_UPDATE_ORDER_LAB,
      actions.BO_UPDATE_ORDER_LOGISTICS,
      actions.BO_ACCESS_ASSETS_LISTING,
      actions.BO_ACCESS_SAMPLER_LISTING,
      actions.BO_ACCESS_ASSETS_DETAIL_VIEW,
      actions.ACCESS_LAB_PORTAL,
    ],
  },
  CRM_TEAM: {
    name: "crm_team",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      actions.ACCESS_COMPANY_LISTING,
      actions.ACCESS_ADD_NEW_COMPANY,
      actions.ACCESS_VIEW_COMPANY,
      actions.ACCESS_EDIT_COMPANY,
      actions.ACCESS_COMPANY_USER_LISTING,
      actions.ACCESS_ADD_LOGISTICS,
      actions.ACCESS_LOGISTICS_LISTING,
      actions.ACCESS_ADD_LAB,
      actions.ACCESS_LAB_LISTING,
      actions.ACCESS_ADD_TEST,
      actions.ACCESS_COMPANY_CATALOG_LISTING,
      actions.ACCESS_MASTER_CATALOG,
      actions.ACCESS_ORDER_LISTING,
      actions.ACCESS_USER_SUMMARY,
      actions.ACCESS_ADD_COMPANY_CATALOG,
      actions.ACCESS_EDIT_COMPANY_CATALOG,
      actions.ACCESS_COMPANY_CATALOG,
      actions.ACCESS_EDIT_USER,
      actions.ACCESS_VIEW_USER_DETAILS,
      actions.ACCESS_ADD_USER,
      actions.ACCESS_CATALOG_MANAGEMENT,
      actions.BO_DOWNLOAD_PURCHASE_ORDER,
      actions.BO_ACCESS_ORDER_DETAILS,
      actions.BO_APPROVE_ORDER_PAYMENT,
      actions.BO_APPROVE_PURCHASE_ORDER,
      actions.BO_UPDATE_ORDER_STATUS,
      actions.BO_UPLOAD_REPORT,
      actions.BO_DOWNLOAD_REPORT,
      actions.BO_ADD_ORDER_INSTRUCTIONS,
      actions.BO_ACCESS_ORDER_INSTRUCTIONS,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ADD_PACKAGE,
      actions.BO_EDIT_PACKAGE,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.BO_ACCESS_BOOK_TEST,
      actions.BO_UPDATE_ORDER_LAB,
      actions.BO_UPDATE_ORDER_LOGISTICS,
      actions.BO_REGRET_ORDER,
      actions.BO_ACCESS_PAYMENT_REMINDER,
      actions.BO_ACCESS_SAMPLER_LISTING,
    ],
  },
  AGNEXT_OPERATIONS: {
    name: "agnext_operations",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      actions.ACCESS_COMPANY_LISTING,
      actions.ACCESS_ADDRESS_SUMMARY,
      actions.ACCESS_ADD_NEW_COMPANY,
      actions.ACCESS_ADD_NEW_ADDRESS,
      actions.ACCESS_VIEW_COMPANY,
      actions.ACCESS_EDIT_COMPANY,
      actions.ACCESS_EDIT_ADDRESS,
      actions.ACCESS_COMPANY_USER_LISTING,
      actions.ACCESS_COMPANY_PICKUPADDRESSES_LISTING,
      actions.ACCESS_COMPANY_BILLINGADDRESSES_LISTING,
      actions.ACCESS_ADD_LOGISTICS,
      actions.ACCESS_VIEW_LOGISTICS,
      actions.ACCESS_EDIT_LOGISTICS,
      actions.ACCESS_LOGISTICS_LISTING,
      actions.ACCESS_ADD_LAB,
      actions.ACCESS_VIEW_LAB,
      actions.ACCESS_EDIT_LAB,
      actions.ACCESS_LAB_LISTING,
      actions.ACCESS_ADD_TEST,
      actions.ACCESS_COMPANY_CATALOG_LISTING,
      actions.ACCESS_MASTER_CATALOG,
      actions.ACCESS_ORDER_LISTING,
      actions.ACCESS_USER_SUMMARY,
      actions.ACCESS_ADD_COMPANY_CATALOG,
      actions.ACCESS_EDIT_COMPANY_CATALOG,
      actions.ACCESS_REMOVE_TEST_FROM_COMPANY_CATALOG,
      actions.ACCESS_COMPANY_CATALOG,
      actions.ACCESS_EDIT_USER,
      actions.ACCESS_VIEW_USER_DETAILS,
      actions.ACCESS_ADD_USER,
      actions.ACCESS_CATALOG_MANAGEMENT,
      actions.BO_DOWNLOAD_PURCHASE_ORDER,
      actions.BO_ACCESS_ORDER_DETAILS,
      actions.BO_APPROVE_ORDER_PAYMENT,
      actions.BO_APPROVE_PURCHASE_ORDER,
      actions.BO_UPDATE_ORDER_STATUS,
      actions.BO_UPLOAD_REPORT,
      actions.BO_DOWNLOAD_REPORT,
      actions.BO_ADD_ORDER_INSTRUCTIONS,
      actions.BO_ACCESS_ORDER_INSTRUCTIONS,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ADD_PACKAGE,
      actions.BO_EDIT_PACKAGE,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.BO_ACCESS_BOOK_TEST,
      actions.BO_UPDATE_ORDER_LAB,
      actions.BO_UPDATE_ORDER_LOGISTICS,
      actions.BO_REGRET_ORDER,
      actions.BO_ACCESS_PAYMENT_REMINDER,
      actions.BO_CREATE_SERVICE_REQUEST,
      actions.BO_ACCESS_ASSETS_LISTING,
      actions.BO_ACCESS_SAMPLER_LISTING,
      actions.BO_ACCESS_ASSETS_DETAIL_VIEW,
    ],
  },
  AGNEXT_FINANCE: { name: "agnext_finance", permissions: [] },
  REGULATORY_BODY_ADMIN: {
    name: "regulatory_body_admin",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      //actions.ACCESS_CONSUMER_PORTAL,
      //actions.BO_ACCESS_BOOK_TEST,
      //actions.BO_ACCESS_PACKAGE_LISTING,
      //actions.BO_ADD_PACKAGE,
      //actions.BO_EDIT_PACKAGE,
      //actions.BO_DOWNLOAD_PURCHASE_ORDER,
      actions.BO_ACCESS_ORDER_DETAILS,
      actions.BO_DOWNLOAD_REPORT,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      //actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.ACCESS_ORDER_LISTING,
      actions.ACCESS_ANALYTICS,
      actions.ACCESS_LAB_PORTAL,
      //actions.ACCESS_COMPANY_USER_LISTING,
      //actions.ACCESS_ADD_USER,
      //actions.ACCESS_VIEW_USER_DETAILS,
      //actions.ACCESS_EDIT_USER,
      actions.BO_DASHBOARD_NEW,
      // actions.BO_DASHBOARD_NEW_SAMPLING,
      actions.BO_DASHBOARD_NEW_COMMODITY,
      actions.BO_DASHBOARD_NEW_TESTING,
      actions.BO_DASHBOARD_NEW_TAT,
      actions.BO_DASHBOARD_NEW_SAMPLING_COVERAGE,
      actions.BO_DASHBOARD_NEW_COMPLIANCE,
      actions.BO_DASHBOARD_NEW_REPORT
      // actions.BO_DASHBOARD_NEW_REGRET
    ],
  },
  COMPANY_ADMIN: {
    name: "company_admin",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      //actions.ACCESS_CONSUMER_PORTAL,
      //actions.BO_ACCESS_BOOK_TEST,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ADD_PACKAGE,
      //actions.BO_EDIT_PACKAGE,
      //actions.BO_DOWNLOAD_PURCHASE_ORDER,
      actions.BO_ACCESS_ORDER_DETAILS,
      actions.BO_DOWNLOAD_REPORT,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.ACCESS_ORDER_LISTING,
      actions.ACCESS_ANALYTICS,
      //actions.ACCESS_LAB_PORTAL,
      //actions.ACCESS_COMPANY_USER_LISTING,
      //actions.ACCESS_ADD_USER,
      //actions.ACCESS_VIEW_USER_DETAILS,
      //actions.ACCESS_EDIT_USER,
      actions.BO_DASHBOARD_NEW,
      // actions.BO_DASHBOARD_NEW_SAMPLING,
      actions.BO_DASHBOARD_NEW_COMMODITY,
      actions.BO_DASHBOARD_NEW_TESTING,
      actions.BO_DASHBOARD_NEW_TAT,
      actions.BO_DASHBOARD_NEW_SAMPLING_COVERAGE,
      actions.BO_DASHBOARD_NEW_REPORT,
      actions.BO_DASHBOARD_NEW_COMPLIANCE
      // actions.BO_DASHBOARD_NEW_REGRET
    ],
  },
  COMPANY_USER: {
    name: "company_user",
    permissions: [actions.ACCESS_CONSUMER_PORTAL],
  },
  SUPPORT_TEAM: {
    name: "support_team",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      actions.ACCESS_ADDRESS_SUMMARY,
      actions.ACCESS_COMPANY_LISTING,
      actions.ACCESS_VIEW_COMPANY,
      actions.ACCESS_ORDER_LISTING,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.ACCESS_LAB_PORTAL,
      actions.BO_ACCESS_ASSETS_LISTING,
      actions.BO_ACCESS_SAMPLER_LISTING,
      actions.ACCESS_COMPANY_USER_LISTING,
      actions.ACCESS_USER_SUMMARY,
      actions.ACCESS_VIEW_USER_DETAILS,
      actions.ACCESS_COMPANY_PICKUPADDRESSES_LISTING,
      actions.ACCESS_COMPANY_BILLINGADDRESSES_LISTING,
      actions.ACCESS_COMPANY_CATALOG_LISTING,
      actions.ACCESS_COMPANY_CATALOG,
      actions.ACCESS_LAB_LISTING,
      actions.ACCESS_LOGISTICS_LISTING,
      actions.ACCESS_ADD_NEW_COMPANY,
      actions.BO_UPDATE_ORDER_LOGISTICS,
      actions.BO_UPDATE_ORDER_LAB,
      actions.BO_ACCESS_ORDER_DETAILS
    ],
  },
  CSC_ADMIN: {
    name: "csc_admin",
    permissions: [
      actions.ACCESS_ADMIN_PORTAL,
      actions.ACCESS_VIEW_COMPANY,
      actions.ACCESS_ORDER_LISTING,
      actions.BO_ACCESS_PACKAGE_LISTING,
      actions.BO_ACCESS_PACAKGE_DETAILS,
      actions.ACCESS_LAB_PORTAL,
      actions.BO_ACCESS_SAMPLER_LISTING,
      actions.ACCESS_LAB_LISTING,
      actions.ACCESS_LOGISTICS_LISTING,
      actions.ACCESS_ADD_NEW_COMPANY,
      actions.BO_UPDATE_ORDER_LOGISTICS,
      actions.BO_UPDATE_ORDER_LAB,
      actions.BO_ACCESS_ORDER_DETAILS,
      actions.BO_DASHBOARD_NEW,
      actions.BO_DASHBOARD_NEW_SAMPLING,
      actions.BO_DASHBOARD_NEW_COMMODITY,
      actions.BO_DASHBOARD_NEW_TESTING,
      actions.BO_DASHBOARD_NEW_TAT,
      actions.BO_DASHBOARD_NEW_SAMPLING_COVERAGE,
      actions.BO_DASHBOARD_NEW_COMPLIANCE,
      actions.BO_DASHBOARD_NEW_REPORT,
      actions.ACCESS_ADD_LAB,
      actions.ACCESS_VIEW_LAB,
      actions.ACCESS_EDIT_LAB
    ],
  },
  COMPANY_FINANCE: { name: "company_finance", permissions: [] },
  LAB_ADMIN: { name: "lab_admin", permissions: [actions.ACCESS_LAB_PORTAL] },
  LAB_USER: { name: "lab_user", permissions: [] },
  LAB_FINANCE: { name: "lab_finance", permissions: [] },
  LOGISTICS_ADMIN: { name: "logistics_admin", permissions: [] },
  LOGISTICS_USER: { name: "logistics_user", permissions: [] },
  LOGISTICS_FINANCE: { name: "logistics_finance", permissions: [] },
};

module.exports = roles;
